import { ShipperUserTableDTO } from '../../../../Domain/DTO/ShipperUserTableDTO';
import { EEntityType } from '../../../../Domain/Enum/EEntityType';
import i18next from '../../../i18n';
import { VolmaContainer } from '../../../../Infrastructure/InversifyInject';
import { VolmaModalActions } from '../../../VolmaModal/VolmaModalActions';
import { Types } from '../../../../Infrastructure/Types';
import { ITableDTO } from '../../../../Domain/ITableDTO';

import { IVolmaTableAction } from '../../../Table/VolmaTable/IVolmaTableProps';
import { ShipperUserActions } from '../ShipperUserActions';
import { AuthenticationService } from '../../../../Infrastructure/Services/AuthService';
import { EUserRole } from '../../../../Domain/Enum/EUserRole';

export class DeleteShipperUsersAction<THelper> implements IVolmaTableAction<THelper>{
    private _modalActions: VolmaModalActions;
    private _actions: ShipperUserActions;
    private _authService: AuthenticationService;

    public Title: string = "shipperuser:DeleteSelectedItem";
    
    public IsAvailable(selectedIds: Array<string>, data: Array<ShipperUserTableDTO>){
        if (selectedIds === undefined || selectedIds.length !== 1)
            return false;

        var itm = data.find(x => x.Id === selectedIds[0]);
        if (itm === undefined)
            return false;

        let currentUser = this._authService.GetCurrentUser();
        if (currentUser.Role === EUserRole.Administrator)
            return true;
        if (currentUser.Role === EUserRole.ShipperLogistExtended)
            return itm.Role === EUserRole.ShipperLogist;
        return false;

    }
    
    public OnActivate(name: string, entity: EEntityType, selectedIds: Array<string>, data: Array<ITableDTO>, dispatch: any, reloadData: () => void) {
        let id = selectedIds !== undefined && selectedIds.length > 0 ? selectedIds[0] : undefined;
        if(id !== undefined){
            dispatch(this._modalActions.OpenConfirmationModal("shipperuser:AreYouSureYouWantToDeleteSelectedItem", () => {
                dispatch(this._actions.DeleteEntity(name, entity, i18next.t("common:Loading"), id, reloadData));
            }));
        }
    }

    constructor(){
        this._modalActions = VolmaContainer.get<VolmaModalActions>(Types.VolmaModalActions);
        this._actions = VolmaContainer.get<ShipperUserActions>(Types.ShipperUserActions);
        this._authService = VolmaContainer.get<AuthenticationService>(Types.AuthenticationService);
    }
}